/* product-gallery-zoom.js
   Powers snippets/custom-gallery.liquid:
     1. Thumbnail hover  -> preview that image in the main view
     2. Thumbnail click  -> open the full-screen lightbox on that image
     3. Hover main image -> show the side zoom panel
     4. Click main image -> open the full-screen lightbox with prev/next nav

   Self-contained vanilla JS, no dependencies. */
(function () {
  function initGallery(root) {
    var main = root.querySelector('.csur__main-image');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.csur__thumb'));
    var zoomPanel = root.querySelector('.csur__zoom-panel');
    var zoomImage = root.querySelector('.csur__zoom-image');
    if (!main) return;

    // Source list, ordered by data-index, used for both swapping and the lightbox.
    // Each source has a display-res URL (full) and a high-res URL (zoom).
    // Thumbnails carry small src + data-full + data-zoom so images load light
    // but the main view / hover-zoom / lightbox stay sharp.
    function srcOf(t) {
      var full = t.getAttribute('data-full') || t.getAttribute('src');
      var zoom = t.getAttribute('data-zoom') || full;
      return { full: full, zoom: zoom };
    }
    var sources = thumbs
      .slice()
      .sort(function (a, b) {
        return (a.dataset.index | 0) - (b.dataset.index | 0);
      })
      .map(srcOf);
    if (!sources.length) {
      var mFull = main.getAttribute('src');
      var mZoom = main.getAttribute('data-zoom') || mFull;
      sources = [{ full: mFull, zoom: mZoom }];
    }

    var current = 0;

    function showIndex(i) {
      current = (i + sources.length) % sources.length;
      var s = sources[current];
      // An <img> with a srcset ignores src changes and keeps showing the
      // srcset-chosen image, so drop srcset when swapping so src wins.
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.setAttribute('src', s.full);
      main.dataset.index = current;
      if (zoomImage) zoomImage.setAttribute('src', s.zoom);
      if (lightboxImg) lightboxImg.setAttribute('src', s.zoom);
    }

    /* ---- Thumbnails: hover to preview in main, click to open full-screen ---- */
    thumbs.forEach(function (thumb) {
      var idx = thumb.dataset.index | 0;
      thumb.addEventListener('mouseenter', function () {
        showIndex(idx);
      });
      thumb.addEventListener('click', function () {
        showIndex(idx);
        openLightbox();
      });
    });

    /* ---- Hover zoom panel ---- */
    if (zoomPanel && zoomImage) {
      zoomImage.setAttribute('src', main.getAttribute('data-zoom') || main.getAttribute('src'));
      main.addEventListener('mouseenter', function () {
        zoomPanel.classList.remove('opacity-0');
        zoomPanel.classList.add('opacity-100');
      });
      main.addEventListener('mouseleave', function () {
        zoomPanel.classList.add('opacity-0');
        zoomPanel.classList.remove('opacity-100');
      });
      main.addEventListener('mousemove', function (e) {
        var rect = main.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        zoomImage.style.transform = 'scale(2)';
        zoomImage.style.transformOrigin = x + '% ' + y + '%';
      });
    }

    /* ---- Lightbox ---- */
    var overlay = document.createElement('div');
    overlay.className = 'csur__lightbox';
    overlay.innerHTML =
      '<button class="csur__lightbox-close" aria-label="Close">&times;</button>' +
      '<button class="csur__lightbox-prev" aria-label="Previous">&#10094;</button>' +
      '<img class="csur__lightbox-image" alt="Enlarged product image">' +
      '<button class="csur__lightbox-next" aria-label="Next">&#10095;</button>';
    document.body.appendChild(overlay);

    var lightboxImg = overlay.querySelector('.csur__lightbox-image');

    if (sources.length <= 1) {
      overlay.querySelector('.csur__lightbox-prev').style.display = 'none';
      overlay.querySelector('.csur__lightbox-next').style.display = 'none';
    }

    function openLightbox() {
      showIndex(current);
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeLightbox() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    main.style.cursor = 'zoom-in';
    main.addEventListener('click', openLightbox);

    overlay.querySelector('.csur__lightbox-close').addEventListener('click', closeLightbox);
    overlay.querySelector('.csur__lightbox-prev').addEventListener('click', function (e) {
      e.stopPropagation();
      showIndex(current - 1);
    });
    overlay.querySelector('.csur__lightbox-next').addEventListener('click', function (e) {
      e.stopPropagation();
      showIndex(current + 1);
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') showIndex(current - 1);
      else if (e.key === 'ArrowRight') showIndex(current + 1);
    });
  }

  function init() {
    document.querySelectorAll('.csur__gallery-wrapper').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
